import { createSelector } from 'reselect'
import sel from '~/utils/selectors-ts'

export default createSelector<any, any, boolean>(
  sel.isLoggingIn,
  isLoggingIn => isLoggingIn
)
